import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useApp();
  const processed = useRef(false);
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    const session_id = m[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        setUser(data.user);
        window.history.replaceState({}, "", "/dashboard");
        nav("/dashboard");
      } catch {
        nav("/login");
      }
    })();
  }, [nav, setUser]);
  return (
    <div className="min-h-screen grid place-items-center bg-pink-50">
      <div className="text-pink-600 font-bold">Signing you in...</div>
    </div>
  );
}
